import React, { Component } from 'react';
import { Switch, Redirect ,Route} from 'react-router-dom';

import Header from '../../components/layout/Header';
import LeftMenu from '../../components/layout/LeftMenu';
import InvoiceAttachments from '../../containers/Invoices/InvoiceAttachments';
import InvoiceSearchPage from '../../containers/Invoices/InvoiceSearchPage';
import VendorInvoiceView from '../../containers/Invoices/VendorInvoiceView';
import InvoiceDashboard from '../DashBoard/InvoiceDashboard';
import VendorReports from '../reports/VendorReports';
import VendorResponseReport from '../reports/VendorResponseReport';
import VendorResponseReportSPD from '../reports/VendorResponseReportSPD';
import Map from '../Map/Map';
import NewServiceRequest from '../ServiceRequest/NewServiceRequest';
import InvoiceContent from '../../components/layout/InvoiceContent';
import ProtectedRoute from '../../util/ProtectedRoute';
import { getPermissionByName } from '../../util/customMethods';

class InvoiceHome extends Component {
  render() {
    // Determine if the user has dashboard permission
    const hasDashboardPermission = getPermissionByName("dashboard");

    return (
      <React.Fragment>
        <Header />
        <LeftMenu />
        <section className="main-content tile">
          <Switch>
            {/* Master-level permission routes */}
            <ProtectedRoute exact path="/dashboard" component={InvoiceDashboard} permissionName="dashboard" />
            <ProtectedRoute exact path="/map" component={Map} permissionName="map" />
            <ProtectedRoute exact path="/newRequest" component={NewServiceRequest} permissionName="dashboard" />
            <ProtectedRoute exact path="/search" component={InvoiceSearchPage} permissionName="search" />
            <ProtectedRoute exact path="/home/attachments" component={InvoiceAttachments} permissionName="towSheets" />
            <ProtectedRoute exact path="/home/" component={InvoiceContent} permissionName="towSheets" />
            
            {/* MODIFIED: Report routes now check report-level permissions */}
            <ProtectedRoute 
              exact 
              path="/ars-usage-report" 
              component={VendorReports} 
              permissionName="reports"
              reportType="ARS_USAGE" 
            />
            <ProtectedRoute 
              exact 
              path="/response-report" 
              component={VendorResponseReport} 
              permissionName="reports"
              reportType="RESPONSE" 
            />
            <ProtectedRoute 
              exact 
              path="/response-report-spd" 
              component={VendorResponseReportSPD} 
              permissionName="reports"
              reportType="RESPONSE_SPD" 
            />
            
            {/* Invoice view doesn't require special permissions */}
            <Route exact path="/invoice/:invoiceId" component={VendorInvoiceView}  />
            
            {hasDashboardPermission && <Redirect to="/dashboard" />}
            {!hasDashboardPermission && <Redirect to="/home" />}
          </Switch>
        </section>
      </React.Fragment>
    );
  }
}

export default InvoiceHome;
